<template>
  <q-card flat class="q-pa-lg bg-grey-1">
    <div class="text-h5 q-mb-md">
      <h3>{{ $t('dass.detailsOfOrder') }}</h3>
    </div>
    <q-timeline color="black" side="right" layout="dense">
      <template v-for="(occurrence, index) in listOccurrencesFormated" :key="index">
        <q-timeline-entry
          :subtitle="occurrence?.OCO_DTA"
          :title="occurrence?.TOC_NOME"
          :icon="lens"
          :color="black"
          :body="occurrence?.TOC_DETALHE"
        />
      </template>
    </q-timeline>
  </q-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'TimelineInfoDetailsOrder', 
  computed: {
    ...mapGetters('orders', { listOccurrences:'getOccurrences', orders: 'getOrders' }),    
    order() {      
       return this.orders.find((item) => item.PED_CODIGO == this.$route.params.ped_codigo)
    },
    listOccurrencesFormated() {      
      const listOccurrence = this.listOccurrences.filter(occ => occ?.FAT_SEQUENCIA == this.order?.FAT_SEQUENCIA)
      return listOccurrence.reduce((acc, cur) => {
        if (!acc.some((item) => item.TOC_CODIGO === cur.TOC_CODIGO)) {
          acc.push(cur);
        }
        return acc;
      }, []);
    }
  },  
  
}
</script>

<style>
.q-card {
  height: 75vh;
  overflow-y: auto;
}
.q-timeline__subtitle {
  font-size: 16px;
}
.q-timeline__title {
  font-weight: bold;
  font-size: 18px;
}
</style>